<template>
    <PerfilSga v-if="teatro.sga === 1" />
    <Perfil v-else/>
</template>

<script>
    import PerfilSga from '@/components/frontend/perfil/PerfilSga';
    import Perfil from '@/components/frontend/perfil/Perfil';

    export default {
        components: {
            PerfilSga, Perfil
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            manager() {
                return this.$store.getters.getFooter;
            }
        }
    }
</script>
